import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { PostLoginResponse } from '../interfaces/post-login';
import { RequestError } from '../../../interfaces/error.interface';
import { PostSignUpResponse } from '../interfaces/post-sign-up';

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  errorCode: number | null;
}

const initialState: AuthState = {
  token: null,
  refreshToken: null,
  errorCode: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    postLoginInitApiAction: (state) => {
      state.errorCode = null;
    },
    postLoginSuccessApiAction: (
      state,
      action: PayloadAction<PostLoginResponse>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refresh_token;
    },
    postLoginFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postSignUpInitApiAction: (state) => {
      state.errorCode = null;
    },
    postSignUpSuccessApiAction: (
      state,
      action: PayloadAction<PostSignUpResponse>
    ) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refresh_token;
    },
    postSignUpFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    authClearAction: (state) => {
      state.token = null;
      state.refreshToken = null;
      state.errorCode = null;
    },
  },
});

export const {
  postLoginInitApiAction,
  postLoginSuccessApiAction,
  postLoginFailureApiAction,
  postSignUpInitApiAction,
  postSignUpSuccessApiAction,
  postSignUpFailureApiAction,
  authClearAction,
} = authSlice.actions;

export default authSlice.reducer;
